// extracted by mini-css-extract-plugin
module.exports = {"baseClass":"StoreBadgeBase_baseClass__N1lN2"};